<script setup lang="ts">
type Enumerations = string[];

const { t, tm } =  useI18n({
  useScope: "local",
});

const { getTrackingConfig } = useTrackingConfig();
const trackingElement = getTrackingConfig('ad', 'buttons','registrationBox');
const trackingButton = getTrackingConfig('ad', 'elements','registrationBox');
const isDesktop = useIsDesktop();
const enumerationCount = computed(() => {
  const messages = tm(`list.enumerations`) as Enumerations;
  if (Array.isArray(messages)) {
    return messages.length;
  }
  return 0;
});

</script>

<template>
  <section
    class="shout-out-box tw-tracking"
    :aria-labelledby="t('title')"
    :data-tracking-id="trackingElement.dataTrackingId"
    :data-page="trackingElement.dataPage"
    :data-headline="t('title')">
    <div class="image">
      <img v-if="!isDesktop" class="desktop" src="/assets/images/conversion/registration_mobile.png" :alt="t('title')" aria-hidden="true" />
      <img v-else class="mobile" src="/assets/images/conversion/registration_desktop.png" :alt="t('title')" aria-hidden="true" />
    </div>
    <div class="info">
      <h2>{{ t('title') }}</h2>
      <ul role="list">
        <li v-for="index in enumerationCount" :key="index" role="listitem">
          <span class="tw-icon-check">
            <Icon name="bi:check" />
          </span> {{ t(`list.enumerations[${index - 1}]`) }}
        </li>
      </ul>
      <tw-button-register
        :data-tracking-id="trackingButton.dataTrackingId"
        :data-page="trackingButton.dataPage"
      />
    </div>

  </section>

</template>

<style scoped lang="scss">
@import "@/assets/styles/tw-variables.scss";
@import "@/assets/styles/tw-mixins.scss";

.shout-out-box {
  background-color: $primary-20;
  display: flex;
  flex-direction: column;
  ul {
    li {
      margin: 0.25rem 0;
    }
  }
  img {
    width:100%;
    height: auto;
  }
  @include tw-is-desktop {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    img {
      width: fit-content;
      max-width: 280px;
      height: auto;
    }
  }
  .image {
    display: flex;
  }
  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    width: 100%;
    h2 {
      margin: 0;
      text-align: center;
      font-size: 1.5rem;
      line-height: 1.5rem;
      @include tw-is-desktop {
        margin: 0;
      }
    }
  }
  .tw-icon-check {
    color: $white;
    margin-right: 0.5rem;
    display: inline-block;
    background-color: $success;
  }
}
</style>

<i18n lang="json">
{
  "de": {
    "title": "Möchtest du auch deine Mietwohnung tauschen?",
     "list": {
       "enumerations": [
         "Direkter Kontakt zum Tauschpartner",
         "Keine doppelte Miete",
         "Keine Massenbesichtigungen"
       ]
     }
  },
  "en": {
    "title": "Do you also want to exchange your rental apartment?",
    "list": {
    "enumerations": [
        "Direct contact with the exchange partner",
        "No double rent",
        "No mass viewings"
    ]
    }
  }
}
</i18n>
